import { useEffect } from 'react';

const DEFAULT_TITLE = 'Kai';

/**
 * Sets document.title for the current page, which browsers use to label
 * history entries. Resets to DEFAULT_TITLE on unmount.
 *
 * For dynamic pages, pass undefined or null while data is loading —
 * the title will remain at the default until a real value is ready.
 *
 * @example
 * usePageTitle('Dashboard')
 * usePageTitle(project?.name ? `Project · ${project.name}` : undefined)
 */
export const usePageTitle = (title: string | null | undefined): void => {
  useEffect(() => {
    if (title) {
      document.title = `${title} · Kai`;
    }
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};
